module.exports = __webpack_public_path__ + "static/bc-f44bff7ff0e53bef64a471bdfda1afb7.png";